import { render, staticRenderFns } from "./banIssue.vue?vue&type=template&id=12963320&scoped=true"
import script from "./banIssue.vue?vue&type=script&lang=js"
export * from "./banIssue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12963320",
  null
  
)

export default component.exports